<template>
  <div class="book-viewer__cats">
    <div class="book-viewer__cats__wrap">
      <h2
        class="book-viewer__cats__title font-sanpro-semibold"
        :class="{
          'primary-color font-size-22 cursor-pointer lib-lesson__cats__title lib-lesson__cats__title__detail': viewDetailLesson,
          'primary-color-txt font-size-24 lib-lesson__cats__title': !viewDetailLesson
        }"
        @click="handleBackList"
      >
        <span v-if="viewDetailLesson && lessonBookViewing.length > 1" class="icon-arrow-left primary-color font-size-18"><span class="path1"></span><span class="path2"></span></span>
        Nhóm bài giảng 
        <span v-if="!viewDetailLesson">({{ lessonBookViewing.length }})</span>
      </h2>
    </div>
    <div class="book-viewer__cats__list">
      <vue-custom-scrollbar v-if="!viewDetailLesson" class="scroll-area scroll-area__cats lesson-groups" :settings="settingsViewBookSidebar">
        <div class="book-viewer__cats__wrap">
          <div v-for="(item, index) of lessonBookViewing" :key="index" class="item" :class="{'active': indexLessonActive === index}">
            <div class="item__head aspect-ratio aspect-ratio--16-9">
              <figure class="margin-0 p-0">
                <img :src="item.imageUrl ? `${cdnLink}${item.imageUrl}` : img404" :alt="item.title">
              </figure>
            </div>
            <div class="item__body">
              <h3 class="item__title font-size-17 font-sanpro-semibold primary-color-txt">
                {{ item.title }}
              </h3>
              <div class="item__action">
                <a href="javascript:;" class="primary-color" @click="handleViewLessonDetail(item, index)">Xem chi tiết</a>
                <a
                  v-if="item && item.script && item.script.fileName"
                  href="javascript:;"
                  class="primary-color"
                  @click="handleViewLessonDetail(item, index, 1)"
                >
                  Kịch bản dạy
                </a>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
      <div v-else class="lesson-detail">
        <div class="book-viewer__cats__wrap">
          <b-tabs class="book-detail__tabs__content">
            <b-tab
              @click="handleViewLessonDetail(lessonBookViewing[indexLessonActive], indexLessonActive)"
            >
              <template v-slot:title>Bài giảng</template>
            </b-tab>
            <b-tab
              v-if="lessonBookViewing[indexLessonActive] && lessonBookViewing[indexLessonActive].script && lessonBookViewing[indexLessonActive].script.fileName"
              :active="tabActive === 1"
              @click="handleViewLessonDetail(lessonBookViewing[indexLessonActive], indexLessonActive, 1)"
            >
              <template v-slot:title>Kịch bản dạy học</template>
            </b-tab>
          </b-tabs>
        </div>
        <vue-custom-scrollbar class="scroll-area scroll-area__cats scroll-area__cats__detail" :settings="settingsViewBookSidebar">
          <div v-if="lessonBookViewing[indexLessonActive] && (lessonBookViewing[indexLessonActive].lessonPlan || lessonBookViewing[indexLessonActive].script)" class="book-viewer__cats__wrap lib-lesson__pages">
            <div 
              class="item position-rel bg-color-light" 
              v-for="(item, index) in tabActive === 0 && lessonBookViewing[indexLessonActive].lessonPlan ? lessonBookViewing[indexLessonActive].lessonPlan.totalPage : lessonBookViewing[indexLessonActive].script ? lessonBookViewing[indexLessonActive].script.totalPage : 0" 
              :class="{
                'active': tabActive === 0 ? pageSettingLessonPlan.page === item : pageSettingScript.page === item,
                'item--2': tabActive === 1
              }" 
              @click="directPage(item)"
              :key="index"
            >
              <div class="item__head">
                <div class="img__wrap">
                  <img :src="lessonBookViewing[indexLessonActive][tabActive === 0 ? 'lessonPlan' : 'script'].fileName ? `${imgCdnUrl}${lessonBookViewing[indexLessonActive][tabActive === 0 ? 'lessonPlan' : 'script'].fileName}-${item}.jpg` : img404" :alt="lessonBookViewing[indexLessonActive].title">
                </div>
              </div>
              <h4 class="item__title margin-0">{{ item }}</h4>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import { APP_CONFIG } from '@/utils/constants'
import vueCustomScrollbar from 'vue-custom-scrollbar'
const img404 = require(`@/assets/images/img_404.jpg`)

export default {
  name: 'EbookLessonSidebar',
  props: {
    pageSettingLessonPlan: Object,
    pageSettingScript: Object
  },
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      img404,
      imgCdnUrl: APP_CONFIG.bookImgCdnUrl,
      urlCmsImg: APP_CONFIG.urlCmsImg,
      cdnLink: APP_CONFIG.cdnLive,
      settingsViewBookSidebar: {
        maxScrollbarLength: 300
      },
      tabActive: 0,
      viewDetailLesson: false
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['lessonBookViewing']),
    indexLessonActive () {
      return (parseInt(this.$route.query.lesson) - 1)
    }
  },
  mounted () {
    this.initSidebar()
  },
  methods: {

    initSidebar () {
      if (this.lessonBookViewing && this.lessonBookViewing.length === 1)
        this.viewDetailLesson = true
    },

    directPage (page) {
      this.$emit('directPage', page)
    },

    handleViewLessonDetail (val, index, type = 0) {
      this.$router.replace({ query: { ...this.$route.query, lesson: index + 1 } })
      this.tabActive = type
      this.$emit('changeTypeLesson', type)
      this.viewDetailLesson = true
    },

    handleBackList () {
      if (this.viewDetailLesson && this.lessonBookViewing.length > 1)
        this.viewDetailLesson = false
    }
  }
}
</script>

<style lang="scss" scoped>
.lib-lesson__cats__title {
  border-bottom: 0;
  padding-bottom: 5px;
  margin-bottom: 20px;

  &__detail {
    margin-bottom: 15px;
  }
}
.scroll-area__cats__detail {
  height: calc(100vh - 290px)!important;
}
.lib-lesson__pages {
  @extend .display-flex-wrap;
  margin: 15px 0;
  
  .item {
    width: calc((100%/2) - 15px);
    margin-bottom: 20px;

    &:nth-child(odd) {
      margin-right: 30px;
    }

    &__head {
      border: 1px solid transparent;
      @extend .aspect-ratio;
      @extend .aspect-ratio--16-9;

      &:before {
        @extend .bg-color-light;
      }
    }

    &__title {
      @extend .primary-bg-color;
      @extend .display-inline-block;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 0 0 10px 0;
      @extend .font-size-13;
      @extend .color-light;
      padding: 5px 10px;
      line-height: 1;
    }

    &.active, &:hover {
      .item__head {
        border-color: $primary_color;
      }
    }

    &--2 {
      @extend .text-center;
      border: 1px solid transparent;

      .item {

        &__head {
          max-width: 70%;
          @extend .margin-center;
          @extend .aspect-ratio--1-1-5;
        }

      }
      &.active, &:hover {
        border-color: $primary_color;

        .item__head {
          border-color: transparent;
        }
      }
    }
  }
}

.lesson-groups {
  .item {
    margin-bottom: 20px;

    &__head {
      border: 1px solid transparent;
    }

    &__body {
      padding: 5px 0;
      border: 1px solid transparent;
    }

    &__title {
      margin-bottom: 15px;
    }

    &__action {
      a {
        &:not(:last-child) {
          &:after {
            content: '|';
            @extend .secondary-color-txt;
            margin: 0 10px;
          }
        }
      }
    }

    &.active, &:hover {
      .item {
        
        &__head {
          border: 1px solid $primary-color;
        }

        &__title {
          @extend .primary-color;
        }
      }
    }
  }
}

@media screen and (max-width: 991px) {

  .scroll-area__cats {
    height: calc(100vh - 225px);
    padding-bottom: 30px;
  }
}
</style>

<style lang="scss">
.book-detail__tabs__content.tabs {

  >div, .nav-tabs {
    width: 100%!important;
  }
  .nav-item:not(:last-child) {
    margin: 0!important;
  }
}
</style>
